import * as checked from 'reporting-data/lib/checked';
export const ReferenceSources = {
  EXTERNAL: 'EXTERNAL',
  LEGACY: 'LEGACY',
  OBJECT: 'OBJECT',
  OPTION: 'OPTION',
  CHECKBOX_OPTIONS: 'CHECKBOX_OPTIONS',
  LEGACY_OPTION: 'LEGACY_OPTION'
};
export const ReferenceSource = checked.symbol(ReferenceSources, 'ReferenceSource');
export const Reference = checked.record({
  id: checked.string(),
  label: checked.string(),
  source: ReferenceSource.optional(),
  description: checked.string().optional(),
  displayOrder: checked.number().optional()
}, 'Reference');